import React from 'react';
import { Card, CardHead, SectionHead, Pill } from '../components/UI';
import s from './Suppliers.module.css';

const SUPPLIERS = [
  { name:'Bharat Petro Supplies', gstin:'33AABCB1234F1ZX', pan:'AABCB1234F', bank:'ICICI ****4421', status:'Active', statusColor:'var(--accent)', invoices:6, comp:92, compColor:'var(--accent)' },
  { name:'Chennai Chemicals Ltd', gstin:'33AACCC5678G1ZY', pan:'AACCC5678G', bank:'HDFC ****8871', status:'Active', statusColor:'var(--accent)', invoices:3, comp:71, compColor:'var(--warn)' },
  { name:'IndoLub Pvt Ltd', gstin:'33AADDI9012H1ZZ', pan:'AADDI9012H', bank:'Axis ****2290', status:'Under review', statusColor:'var(--warn)', invoices:1, comp:41, compColor:'var(--danger)' },
  { name:'Tamil Agro Fuels', gstin:'33AAEEE3456I1ZA', pan:'AAEEE3456I', bank:'SBI ****6641', status:'Active', statusColor:'var(--accent)', invoices:4, comp:81, compColor:'var(--info)' },
];

export default function Suppliers({ navigate }) {
  return (
    <div>
      <SectionHead
        title="Registered suppliers (22)"
        action={
          <button className={s.btnPrimary} onClick={() => navigate('onboarding')}>
            <i className="ti ti-user-plus" /> Onboard new
          </button>
        }
      />
      <div className={s.supGrid}>
        {SUPPLIERS.map(sup => (
          <div key={sup.name} className={s.supCard}>
            <div className={s.supName}>{sup.name}</div>
            {[
              ['GSTIN', sup.gstin],
              ['PAN', sup.pan],
              ['Bank', sup.bank],
              ['Status', <span style={{color:sup.statusColor}}>{sup.status}</span>],
              ['Invoices this month', sup.invoices],
              ['Avg compliance', <span style={{color:sup.compColor}}>{sup.comp}/100</span>],
            ].map(([k,v],i) => (
              <div key={i} className={s.supRow}>
                <span className={s.sk}>{k}</span>
                <span className={s.sv}>{v}</span>
              </div>
            ))}
          </div>
        ))}
      </div>

      <Card>
        <CardHead title="Supplier compliance overview" />
        <div className={s.tableWrap}>
          <table className={s.table}>
            <thead>
              <tr><th>Supplier</th><th>Contract expiry</th><th>NOC</th><th>Bank verified</th><th>Compliance avg</th><th>Status</th></tr>
            </thead>
            <tbody>
              <tr><td>Bharat Petro Supplies</td><td>Dec 2026</td><td><Pill type="ready">Yes</Pill></td><td><Pill type="ready">Yes</Pill></td><td style={{color:'var(--accent)'}}>92/100</td><td><Pill type="ready">Active</Pill></td></tr>
              <tr><td>Reliance Trading Co.</td><td>Mar 2027</td><td><Pill type="ready">Yes</Pill></td><td><Pill type="ready">Yes</Pill></td><td style={{color:'var(--accent)'}}>89/100</td><td><Pill type="ready">Active</Pill></td></tr>
              <tr><td>Tamil Agro Fuels</td><td>Sep 2026</td><td><Pill type="ready">Yes</Pill></td><td><Pill type="ready">Yes</Pill></td><td style={{color:'var(--info)'}}>81/100</td><td><Pill type="ready">Active</Pill></td></tr>
              <tr><td>Chennai Chemicals Ltd</td><td>Jun 2026</td><td><Pill type="pending">Renewing</Pill></td><td><Pill type="ready">Yes</Pill></td><td style={{color:'var(--warn)'}}>71/100</td><td><Pill type="pending">Pending</Pill></td></tr>
              <tr><td>IndoLub Pvt Ltd</td><td>Jan 2026</td><td><Pill type="risk">Expired</Pill></td><td><Pill type="risk">Mismatch</Pill></td><td style={{color:'var(--danger)'}}>41/100</td><td><Pill type="risk">Hold</Pill></td></tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
